"use client";

import Script from "next/script";
import { FC, IframeHTMLAttributes, useEffect } from "react";

// -----------------------------------------------------------------------

export type ITallyIframeProps = IframeHTMLAttributes<HTMLIFrameElement> & {
  url?: string;
};

const TallyIframe: FC<ITallyIframeProps> = (props) => {
  const { url, className, ...other } = props;

  useEffect(() => {
    if (window.Tally) {
      window.Tally.loadEmbeds();
    }
  }, []);

  return (
    <>
      {url && (
        <>
          <iframe
            className={className}
            data-tally-src={url}
            loading="lazy"
            title="Tally.so Form"
            {...other}
          />
          <Script src="https://tally.so/widgets/embed.js" />
        </>
      )}
    </>
  );
};

export default TallyIframe;
